import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import { AppLayout } from "@/components/layout/AppLayout";
import { RequireAuth } from "@/components/layout/RequireAuth";
import { InventoryGrid } from "@/components/inventory/InventoryGrid";
import { ServerDetail } from "@/components/inventory/ServerDetail";
import { ContractList } from "@/components/contracts/ContractList";
import { ContractEditor } from "@/components/contracts/ContractEditor";
import { RenewalQueue } from "@/components/renewals/RenewalQueue";
import { IdleInventory } from "@/components/idle/IdleInventory";
import { RevenueDashboard } from "@/components/revenue/RevenueDashboard";
import { DeploymentRevenueDetail } from "@/components/revenue/DeploymentRevenueDetail";
import { AdminPage } from "@/components/admin/AdminPage";
import { ToastHost } from "@/components/shared/Toast";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/inventory" replace />} />
          <Route path="/inventory" element={<InventoryGrid />} />
          <Route path="/inventory/:id" element={<ServerDetail />} />
          <Route path="/revenue" element={<RevenueDashboard />} />
          <Route path="/revenue/deployment/:id" element={<DeploymentRevenueDetail />} />
          <Route path="/contracts" element={<ContractList />} />
          <Route path="/contracts/:id" element={<ContractEditor />} />
          <Route path="/renewals" element={<RenewalQueue />} />
          <Route path="/idle" element={<IdleInventory />} />
          <Route
            path="/admin"
            element={
              <RequireAuth role="admin">
                <AdminPage />
              </RequireAuth>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/inventory" replace />} />
      </Routes>
      <ToastHost />
    </>
  );
}
